'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {

    /**
     *  update shopping cart content
     */
    UPDATE: 'CART_UPDATE',

    // submit_changes or load_date failed
    UPDATE_FAILED: 'CART_UPDATE_FAILED',

    // adding new item to shopping cart or updating existing
    CHANGE_AMOUNT: 'CART_CHANGE_AMOUNT',

    LOAD_DATA: 'CART_LOAD_DATA',

    // send changes to server
    SUBMIT_CHANGES: 'CART_SUBMIT_CHANGES',

    ADD_BY_EAN: 'ADD_BY_EAN',

    // can discard changes for single product (or all pending changes)
    //DISCARD_CHANGES: 'CART_DISCARD_CHANGES',

    EMPTY: 'CART_EMPTY',

    ORDERED: 'CART_ORDERED',

    ORDER_FAILED: 'CART_ORDER_FAILED',

    OPTIONS_CHANGED: 'CART_OPTIONS_CHANGED',

    SORT_ITEMS: 'CART_SORT_ITEMS'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/action-types.js
// module id = 585
// module chunks = 0